export default class Header {
    constructor() {
        this.elements = {
            target: document.querySelector(".js-header"),
            offcanvas: document.querySelector(".js-offcanvas"),
            offcanvasTrigger: document.querySelector(".js-toggle-offcanvas"),
            offcanvasLabel: document.querySelector(".js-header-toggle-label")
        };

        if (this.elements.offcanvasLabel) {
            this.offcanvasOpenLabel = this.elements.offcanvasLabel.dataset.labelOpen;
            this.offcanvasCloseLabel = this.elements.offcanvasLabel.dataset.labelClose;
        }

        this.settings = {
            delta: 10,
            offcanvasState: false
        };

        this.lastScrollTop = 0;
        this.isDocumentReady = false;

        // Bind this to functions
        this.onToggleOffcanvas = this.onToggleOffcanvas.bind(this);
        this.onScroll = this.onScroll.bind(this);

        if (this.elements.target) {
            this.targetHeight = this.elements.target.offsetHeight;

            this._setDOMReferences();
        }
    }

    _setDOMReferences() {
        if (this.elements.offcanvas && this.elements.offcanvasTrigger) {
            this.elements.offcanvasTrigger.addEventListener(
                "click",
                this.onToggleOffcanvas
            );
        }

        window.addEventListener("scroll", this.onScroll);
        window.addEventListener("resize", this.onResize);
    }

    onToggleOffcanvas() {
        this.settings.offcanvasState
            ? (this.settings.offcanvasState = false)
            : (this.settings.offcanvasState = true);

        let label = "";

        if (this.offcanvasOpenLabel && this.offcanvasCloseLabel) {
            label = this.offcanvasOpenLabel;
        }

        if (this.settings.offcanvasState) {
            this.elements.offcanvasTrigger.classList.add("is--open");
            this.elements.offcanvas.classList.add("is--visible");
            if (label != "") {
                label = this.offcanvasCloseLabel;
            }
        } else {
            this.elements.offcanvasTrigger.classList.remove("is--open");
            this.elements.offcanvas.classList.remove("is--visible");
        }

        if (label != "") {
            this.elements.offcanvasLabel.innerHTML = label;
        }
    }

    onScroll() {
        const st = window.pageYOffset || document.documentElement.scrollTop;

        if (Math.abs(st - this.lastScrollTop) <= this.settings.delta) {
            return;
        }

        if (st > this.lastScrollTop) {
            // scroll down
            if (
                !this.settings.offcanvasState &&
                document.readyState == "complete"
            ) {
                this.elements.target.classList.add("header--up");
            }
        } else {
            // scroll up
            this.elements.target.classList.remove("header--up");
        }

        this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
}
